const listeners = new Set();
const completed = new Map();

export const subscribeProductEvents = (listener) => {
  if (typeof listener !== 'function') return () => {};
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const notifyProductEvent = (payload) => {
  const key = payload?.activityId && `${payload.companyId}:${payload.branchId}:${payload.activityId}`;
  if (key && completed.has(key)) return completed.get(key);
  const work = Promise.all([...listeners].map((listener) => {
    try { return listener(payload); } catch (error) { return Promise.reject(error); }
  }));
  if (key) {
    completed.set(key, work);
    if (completed.size > 200) completed.delete(completed.keys().next().value);
  }
  // WebSocket callers may ignore this promise; the activity provider awaits
  // it and displays a retry if the mounted screen could not reconcile.
  work.catch(() => { if (key) completed.delete(key); });
  return work;
};

export const invalidateProducts = (branchId, meta = {}) => {
  notifyProductEvent({
    type: 'products.invalidated',
    branchId: branchId ?? null,
    ...meta,
  });
};
